import { all, call, put, takeLatest } from "redux-saga/effects";
import { GET_COMBO_NGUON_KHACH_HANG } from "actions/NguonKhachHang/actionTypes";
import {
  getComboNguonKhachHangSuccess,
  getComboNguonKhachHangFailure,
} from "actions/NguonKhachHang";
import NguonKhachHangApi from "service/nguonKhachHangApi";
import { pushNotification } from "utils/notifications";

function* getComboNguonKhachHang(action) {
  try {
    const response = yield call(NguonKhachHangApi.combo, action.dataSearch);
    if (response.ok) {
      yield put(getComboNguonKhachHangSuccess(response.data));
    } else {
      pushNotification("Lỗi xảy ra", "error", "TOP_CENTER", 1000);
      yield put(getComboNguonKhachHangFailure());
    }
  } catch (error) {
    pushNotification("Lỗi xảy ra", "error", "TOP_CENTER", 1000);
    yield put(getComboNguonKhachHangFailure());
  }
}

function* watchGetRequest() {
  yield takeLatest(GET_COMBO_NGUON_KHACH_HANG, getComboNguonKhachHang);
}

export default function* sagas() {
  yield all([watchGetRequest()]);
}
